<template>
    <section class="layout">
        <Navigation></Navigation>
        <div class="layout-content">
            <Menu 
                class="layout-content__menu"
                :class="[isCollapse ? 'hide' : 'show']"
            ></Menu>
            <div class="layout-content__main">
                <el-breadcrumb class="layout-content__bread fyc" separator="/">
                    <span
                        class="icon"
                        :class="[isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold']"
                        @click="changeMenu"
                    ></span>
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">
                        {{ item.title }}
                        <span
                            v-if="item.desc"
                            class="bread-desc"
                        >{{item.desc}}</span>
                    </el-breadcrumb-item>

                </el-breadcrumb>
                <div 
                    class="route-box"
                    :class="[isCollapse ? 'hide' : 'show']"
                >
                    <transition name="router-fade" appear>
                        <router-view></router-view>
                    </transition>
                </div>
                
            </div>
        </div>
    </section>
</template>

<script>
import Vuex from 'vuex';
import Menu from './menu.vue';
import Navigation from './navigation.vue';
export default {
    data() {
        return {
            isPos: true
        };
    },
    components: {
        Menu,
        Navigation
    },
    computed: {
        ...Vuex.mapState({
            isCollapse: (state) => state.isCollapse
        }),
        
        breadList() {
            return this.$route.meta.bread || [];
        }
    },
    methods: {
        
        changeMenu() {
            this.$store.commit('updateCollapse', !this.isCollapse);
        },
        
    },
    mounted() {

    }
};
</script>

<style lang="less">
.layout {
    height: 100%;
    background: #f0f2f5;
    display: flex;
    flex-direction: column;
    &-content {
        flex: 1;
        display: flex;
        &__menu {
            height: calc(100vh);
            // height: calc(100vh - 62px);
            overflow-y: auto;
            position: relative;
            overflow-x: hidden;
            transition: all 0.24s linear;
            &.show {
                flex: 0 0 200px;
            }
            &.hide {
                flex: 0 0 64px;
            }
            
        }
        &__main {
            flex: 1;
            box-sizing: border-box;
            position: relative;
        }
        &__bread {
            width: 100%;
            z-index: 9;
            height: 40px;
            background: white;
            color: rgba(0, 0, 0, 0.9);
            font-size: 18px;
            box-sizing: border-box;
            padding-left: 20px;
            border-bottom: 1px solid #f0f2f5;
            position: relative;
            .bread-desc {
                font-size: 10px;
                color: rgba(0, 0, 0, 0.6);
                padding-left: 8px;
            }
            .bread-right {
                position: absolute;
                right: 10px;
                top: 0;
                height: 40px;
                display: flex;
                align-items: center;
                color: #FF0000;
                font-size: 12px;
                .el-button {
                    margin-left: 10px;
                    font-size: 12px;
                }
            }
        }
    }
}
.router-fade-enter,
.router-fade-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
.router-fade-enter-active {
    transition: all 0.3s ease;
}
.icon {
    font-size: 25px;
    color: #666;
    cursor: pointer;
    margin-right: 20px;
}
.route-box {
    padding: 10px;
    height: calc(100vh - 42px);
    
    overflow-y: auto;
    overflow-x: auto;
    box-sizing: border-box;
    &.show {
        width: calc(100vw - 200px);
    }
    &.hide {
        width: calc(100vw - 64px);
    }
}

.route-box main{
    min-height: 100%;
    background: white;
    border-radius: 2px;
}
.dont-tips {
    color: #020202aa;
    margin-left: 10px;
    cursor: pointer;
    &:active {
        opacity: 0.7;
    }
}

</style>
